import {CustomDataSource, ImageryLayer, Viewer} from 'cesium';
import {A0} from '../entities/A0.entity';

export interface MapperViewer extends Viewer {
  canvasWidth: number;
  plan: A0;
  user: any;
  type_risque: string;
  canvasMode: string;
  snapshot: any;
  hasBeenCentered: boolean;
}

export enum LayerLoadType {
  MoveEnd = 'moveEnd',
  Instant = 'instant',
  Manual = 'manual'
}
export enum LayerType {
  DataSource = 'dataSource',
  Imagery = 'imagery'
}

export interface Layer {
  id: string;
  name: string;
  active: boolean;
  viewer: MapperViewer;
  loadType: LayerLoadType;
  isLoading?: boolean;

  initialize(viewer: MapperViewer): void;
  loadData(): void;
  remove(): void;
  setActive(active: boolean): void;
  onBeforePrint(): void;
  onAfterPrint(): void;
}

export class LayerDatasource implements Layer {
  dataSource: CustomDataSource;
  active: boolean;
  id: string;
  loadType: LayerLoadType;
  name: string;
  viewer: MapperViewer;

  hasLabel?: boolean;
  labelVisible?: boolean;
  labelDistance?: number;

  hasDetail?: boolean;
  detailVisible?: boolean;

  initialize(viewer: MapperViewer): void {}

  loadData(): void {}

  remove(): void {}

  setActive(active: boolean): void {}

  onBeforePrint(): void {}

  onAfterPrint(): void {}
}

export class LayerImagery implements Layer {
  imageryLayer: ImageryLayer;
  active: boolean;
  id: string;
  name: string;
  viewer: MapperViewer;
  loadType: LayerLoadType;


  initialize(viewer: MapperViewer): void {}

  loadData(): void {}

  remove(): void {}

  setActive(active: boolean): void {}

  onBeforePrint(): void {}

  onAfterPrint(): void {}
}


export type BBox = {
  west: number;
  south: number;
  east: number;
  north: number;
};
